import { render, staticRenderFns } from "./BaseTypingIndicator.vue?vue&type=template&id=13e61a94&scoped=true"
import script from "./BaseTypingIndicator.vue?vue&type=script&lang=js"
export * from "./BaseTypingIndicator.vue?vue&type=script&lang=js"
import style0 from "./BaseTypingIndicator.vue?vue&type=style&index=0&id=13e61a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e61a94",
  null
  
)

export default component.exports